import type { RemoveParentControlsMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { RemoveParentControlsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useDeleteParentControls = createMutationHook({
  name: 'deleteParentControls',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.control.deleteParents.mutationOptions({ onSuccess }),
  mapInput: (input: { ParentId: string; ControlIds: string[] }) => input,
  invalidate: (trpc) => [
    trpc.frontend.control.register.queryKey(),
    trpc.frontend.control.controlsBasic.queryKey(),
    // COI-471 parity: Apollo twin also evicts `control_group`.
    trpc.frontend.controlGroup.pathKey(),
  ],
  mapResponse: (result: {
    affected_rows: number;
  }): RemoveParentControlsMutation => ({
    delete_control_parent: {
      __typename: 'control_parent_mutation_response',
      affected_rows: result.affected_rows,
    },
  }),
  graphqlDocument: RemoveParentControlsDocument,
  graphqlVariables: (input: { ParentId: string; ControlIds: string[] }) => ({
    ...input,
  }),
  evictFields: [
    'control',
    'control_group',
    'control_aggregate',
    'control_group_aggregate',
  ],
});
